import { ReservoirChain } from "@reservoir0x/reservoir-sdk";
import { Chain, base, baseSepolia, ethereum, sepolia } from "thirdweb/chains";
import { GameInfo, Stage } from "../../analytics/GameInfo";

export class Web3Config {
    readonly #appName = "Cityverse Tycoon";
    readonly #appDescription = "";
    readonly #infuraApiKey = "0d99d4d1fcf0496f973af67782fbea08";
    readonly #thirdWebclientId = "2a7c8cb0b3245afc4df628e96b6fbe53";
    readonly #thirdWebFactoryAddress = "0xcEac86626c7c5571118Cb7A3522d83B28c7c419E";
    readonly #crossmintProjectId = "91f4d56e-e8c8-4dbe-9ad4-f374b36f0305";
    readonly #crossmintBuildingWithMintCollectionId = "770264d6-371f-4417-a8a4-e017b35f245c";
    readonly #crossmintBuildingCollectionId = "611375d9-bbd8-45fb-a6a3-79f49aa9b672";
    readonly #crossmintBuildingContractAddress = "0x685f63D7137eabf05A6EBA528F25D850f1Eca496";
    readonly #l1BuildingsContractAddress = "0x13195269d9C5036fDAf7CE018f2b25f3C657e7fD";
    readonly #crossmintStoreCollectionId = "2b3f3580-1a63-44a0-9d57-74404d08e341";
    readonly #buildingCollectionAddress = "0x685f63D7137eabf05A6EBA528F25D850f1Eca496";
    readonly #packagesCollectionAddress = "0x020FA69b70C0DF82A0BEf5f8f652e746E68079ed";
    readonly #giftPackagesCollectionAddress = "0x487DcC128cE132b812948388e0ac9E1cB9A4d231";
    readonly #l1PackageCollectionAddress = "0xE8914F86D3A81f17D2dD16710259720621b7F026 ";
    readonly #piggyClubCollectionAddress = "0x6cbaD21F63566741c80aBB0c1ff1C36B95498677";
    readonly #reservoirApiKey = "3bcb8aca-ab9f-5e93-b7b4-2fbb45515597";
    readonly #reservoirSourceName = "cityversetycoon.com";
    readonly #reservoirApiUrl = "https://api-base.reservoir.tools/";
    readonly #multicallAddress = "0xcA11bde05977b3631167028862bE2a173976CA11";
    readonly #usdcCurrencyAddress = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
    readonly #monCurrencyAddress = "0xc555d625828c4527d477e595ff1dd5801b4a600e";

    public constructor(
        private readonly gameInfo: GameInfo
    ) { }

    public get appName(): string {
        return this.#appName;
    }

    public get appDescription(): string {
        return this.#appDescription;
    }

    public get infuraApiKey(): string {
        return this.#infuraApiKey;
    }

    public get targetChain(): Chain {
        return this.gameInfo.serverStage === Stage.DEVELOPMENT ? baseSepolia : base;
    }

    public get piggyChain(): Chain {
        return this.gameInfo.serverStage === Stage.DEVELOPMENT ? sepolia : ethereum;
    }

    public get ethL1Chain(): Chain {
        return this.gameInfo.serverStage === Stage.DEVELOPMENT ? sepolia : ethereum;
    }

    public get reservoirCurrency(): string {
        return this.gameInfo.serverStage === Stage.DEVELOPMENT ? "0x0000000000000000000000000000000000000000" : this.#usdcCurrencyAddress;
    }

    public get reservoirDevUsdcCurrency(): string {
        return this.gameInfo.serverStage === Stage.DEVELOPMENT ? "0x036CbD53842c5426634e7929541eC2318f3dCF7e" : this.#usdcCurrencyAddress;
    }

    public get reservoirTargetChain(): ReservoirChain {
        return {
            active: true,
            baseApiUrl: this.#reservoirApiUrl,
            id: this.targetChain.id,
            name: this.targetChain.name
        };
    }

    public get thirdWebclientId(): string {
        return this.#thirdWebclientId;
    }

    public get thirdWebFactoryAddress(): string {
        return this.#thirdWebFactoryAddress;
    }

    public get crossmintEnvironment(): string {
        return this.gameInfo.serverStage === Stage.DEVELOPMENT ? "staging" : "production";
    }

    public get crossmintProjectId(): string {
        return this.#crossmintProjectId;
    }

    public get crossmintBuildingWithMintCollectionId(): string {
        return this.#crossmintBuildingWithMintCollectionId;
    }

    public get crossmintBuildingCollectionId(): string {
        return this.#crossmintBuildingCollectionId;
    }

    public get crossmintBuildingContractAddress(): string {
        return this.#crossmintBuildingContractAddress;
    }

    public get l1BuildingsContractAddress(): string {
        return this.#l1BuildingsContractAddress;
    }

    public get crossmintStoreCollectionId(): string {
        return this.#crossmintStoreCollectionId;
    }

    public get buildingCollectionAddress(): string {
        return this.#buildingCollectionAddress;
    }

    public get packagesCollectionAddress(): string {
        return this.#packagesCollectionAddress;
    }

    public get giftPackagesCollectionAddress(): string {
        return this.#giftPackagesCollectionAddress;
    }

    public get l1PackageCollectionAddress(): string {
        return this.#l1PackageCollectionAddress;
    }

    public get piggyClubCollectionAddress(): string {
        return this.#piggyClubCollectionAddress;
    }

    public get reservoirApiKey(): string {
        return this.#reservoirApiKey;
    }

    public get reservoirSourceName(): string {
        return this.#reservoirSourceName;
    }

    public get multicallAddress(): string {
        return this.#multicallAddress;
    }

    public get usdcCurrencyAddress(): string {
        return this.#usdcCurrencyAddress;
    }

    public get monCurrencyAddress(): string {
        return this.#monCurrencyAddress;
    }
}
